module.exports = __webpack_public_path__ + "img/bookmark-report.bcca7ac5.png";